import HomeTopBanner from '@eternal/Components/Banner/HomeTopBanner';
import React from 'react';

const HomeBanner = ({ section, region, lang }) => {
  return (
    <>
      <HomeTopBanner region={region} lang={lang} sectionContent={section[0]} />
    </>
  );
};
export default HomeBanner;
